module.exports = __webpack_public_path__ + "static/media/templo2024.634d0c5b.jpg";